import React from 'react'
import DropZone from 'react-dropzone'
import { Button } from '@driftt/tide'
import cx from 'classnames'
import { FileAPI } from 'api'

import './style.css'

const Image = ({ url, imageClassName, description, backgroundColor, onUpload }) => {
  const onDrop = files => {
    const file = files[0]
    const data = new FormData()
    data.append('file', file)
    FileAPI
      .post('/upload', data)
      .then(response => response.data)
      .then(response => {
        onUpload(response.url)
      })
  }
  return (
    <div className="image-preview">
      <DropZone
        className="image-preview-dropzone"
        style={{ backgroundColor, borderColor: backgroundColor, color: backgroundColor && 'white' }}
        onDrop={onDrop}
      >
        <img alt="" src={url} className={cx('image-preview-image', imageClassName)}/>
        Drag and Drop or Upload
      </DropZone>
      <div className="image-preview-description">
        {description}
        <DropZone className="image-preview-upload" onDrop={onDrop}>
          <Button type="secondary">Upload</Button>
        </DropZone>
      </div>
    </div>
  )
}

export default Image
